<template>
  <div class="info-box" :class="getBackgroundClass">
    <div class="row">
      <div class="col-12 col-md-2 d-print-none">
        <div class="info-box__icon">
          <iconWarning class="icon" v-if="type === 'warning'"></iconWarning>
        </div>
      </div>
      <div class="col-12 col-md-10">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import iconWarning from '@/assets/icons/warning-orange.svg'

export default {
  name: 'CiInfoBox',
  components: {
    iconWarning,
  },
  props: {
    type: {
      type: String,
      default: null,
    },
  },
  computed: {
    getBackgroundClass() {
      return {
        warning: this.type === 'warning',
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.info-box {
  border-radius: 4px;
  border: 1px solid rgba(155, 155, 155, 0.5);
  box-shadow: 0 2px 23px 0 #ededed;
  margin: 20px 0;
  overflow: hidden;
  padding: 20px;
  position: relative;

  @include media-breakpoint-up(md) {
    padding: 35px;
  }

  &.warning {
    border: 1px solid #f8e71c;
    background-color: rgba(248, 231, 28, 0.15);
  }
}

.info-box__icon {
  align-items: center;
  display: flex;
  justify-content: center;
}

.icon {
  width: 60px;
  height: auto;
  margin: 0 0 20px 0;

  @include media-breakpoint-up(md) {
    margin: 5px 0 0 0;
  }
}
</style>
